"use client";

import styles from "./styles/ContributingOrganizationsWidget.module.scss";
import ClickableLink from "../utilities/ClickableLink";
import classNames from "classnames";
import { useDirectoryUrl } from "./hooks/useDirectoryUrl";
import ImageComponent from "../utilities/ImageComponent";
import { Suspense, use } from "react";
import ContributingOrgsSVG from "../../assets/images/contributing-orgs.svg";
import { observer } from "mobx-react";

function ContributingOrganizationsCount(props: {
  contributingOrganizationsCountPromise: Promise<number>;
}) {
  const count = use(props.contributingOrganizationsCountPromise);
  let num = count === 0 ? "" : count >= 100 ? "99+" : count;

  return <span>{num}</span>;
}

export const ContributingOrganizationsWidget = observer(
  (props: { contributingOrganizationsCountPromise: Promise<number> }) => {
    const directoryUrl = useDirectoryUrl();

    if (!directoryUrl) {
      return <></>;
    }

    const blockHeadClassName = classNames({
      "sb-blockHead": true,
      "sb-organization-color-block-bg": true,
      "sb-block-head-border": true,
      [styles.header]: true,
    });

    return (
      <div className={classNames(styles.widget, styles.container)}>
        <ClickableLink href={directoryUrl}>
          <div className={blockHeadClassName}>
            View Contributing Organizations
          </div>
          <ImageComponent
            isBackground={true}
            src={ContributingOrgsSVG}
            className={styles.imageContent}
          >
            <Suspense>
              <ContributingOrganizationsCount
                contributingOrganizationsCountPromise={
                  props.contributingOrganizationsCountPromise
                }
              />
            </Suspense>
          </ImageComponent>
        </ClickableLink>
      </div>
    );
  },
);
